module.exports = __webpack_public_path__ + "resources/img/img_tibero4_m_en.adace181e6bd0d3e1a1a01b87b83e28f.png";